<template>
  <div class="main">
    <Header
      :show="true"
      title="车辆列表"
      left="prepage"
      right="create"
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="管理车辆信息，主要用于加油功能"
      />
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{ row }">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="车辆名称">
                <span>{{ row.vehicleName }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.vehicleNo }}</span>
              </el-form-item>
              <el-form-item label="油箱容量">
                <span>{{ row.fuelTankCap }}L</span>
              </el-form-item>
              <el-form-item label="车辆类型">
                <span>
                  {{ getCarTypeValue(row.typeCode).name || row.typeCode }}
                </span>
              </el-form-item>
              <el-form-item
                label="操作"
                v-if="checkPermission([403]) || checkPermission([404])"
              >
                <el-button
                  v-if="checkPermission([403])"
                  type="primary"
                  size="mini"
                  @click="handleClickUpdate(row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="checkPermission([404])"
                  type="danger"
                  size="mini"
                  @click="handleClickDelete(row)"
                >
                  删除
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" type="index" align="center" width="50" />
        <el-table-column
          label="车辆名称"
          prop="vehicleName"
          show-overflow-tooltip
          width="100"
        />
        <el-table-column
          label="车牌号"
          prop="vehicleNo"
          show-overflow-tooltip
          width="100"
        />
        <el-table-column label="车辆类型" prop="typeCode" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ getCarTypeValue(row.typeCode).name || row.typeCode }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth > 380 ? 5 : 3"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #ffffff" />
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog, ImagePreview } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import { parseTime } from "@/utils";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { getList, deleteVehicle as deleteOne } from "@/api/vehicleManager.js";
import { getDicyType } from "@/api/dict";

export default {
  name: "ServiceSystemSupplier",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      carTypeList: [],
      listQuery: {
        limit: 10,
        page: 1,
      },
      isLoading: false,
      table: {
        listLoading: false,
        fullWidth: document.documentElement.clientWidth,
        key: 0,
        total: 0,
        data: [],
      },
      expandRowKeys: [],
      handleRowKey(row) {
        return row.id;
      },
      loading: false,
    };
  },
  created() {
    this.handleClickQuery();
    this.getCarType();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleClickRight() {
      this.$router.push({
        path: "/service/system/vehicle/create",
        query: {},
      });
    },
    getCarType() {
      const that = this;
      getDicyType({ type: "cartype" })
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const { data: dictData } = data;
            const carTypeDict = dictData?.[0].dictDataList || [];
            const list = [{ name: "全部", value: undefined }];
            carTypeDict.forEach((dict) => {
              list.push({
                name: dict.label,
                value: dict.code,
              });
            });
            that.carTypeList = list;
          }
        })
        .catch(() => false);
    },
    getCarTypeValue(code) {
      return this.carTypeList.find((type) => type.value === code) || {};
    },
    handleTableRowClick(row, column, event) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleRowClassName({ row, rowIndex }) {
      return "normal-row";
    },
    handleCellStyle({ row, column, rowIndex, columnIndex }) {
      return "";
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        showPhoneAlarm(true, "toast", null, 2000, null, "工程配置", "刷新完成");
      }, 1000);
    },
    handleClickQuery() {
      const payload = {
        page: {
          current: this.listQuery.page,
          size: this.listQuery.limit,
        },
        where: {
          "desc_vehicle.createTime": 1,
        },
      };
      getList(payload)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            this.table.total = data.page.total;
            this.table.data = data.page.records;
          }
        })
        .catch(function (error) {});
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/system/vehicle/update",
        query: row,
      });
    },
    handleClickDelete(row) {
      Dialog.confirm({
        title: "确认删除此车辆信息？",
      })
        .then(() => {
          this.loading = true;
          const data = [row.id];
          deleteOne(data)
            .then((response) => {
              const { data } = response;
              if (
                showPhoneAlarm(
                  true,
                  "toast",
                  null,
                  2000,
                  data.code,
                  "删除",
                  data.message
                )
              ) {
                this.loading = false;
                this.table.data.splice(this.table.data.indexOf(row), 1);
              }
            })
            .catch(function (error) {});
        })
        .catch(() => {
          showPhoneAlarm(true, "toast", null, 2000, 200, "删除", "取消");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// 系统样式修改
::v-deep .el-form-item__label {
  width: 20%;
  text-align: right;
  // margin-right: 20px;
}
::v-deep .el-table__expanded-cell[class*="cell"] {
  padding: 20px 10px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
::v-deep .van-cell__title {
  max-width: 30%;
}
::v-deep .van-cell__value {
  max-width: 70%;
}
::v-deep .el-table th > .cell {
  padding-left: 5px;
  padding-right: 5px;
}
::v-deep .el-table td > .cell {
  padding-left: 5px;
  padding-right: 5px;
}
::v-deep .van-tag {
  margin: 0 3px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F7F8FA;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
